(function ($) {
  Drupal.behaviors.mppFilterSetV1 = {
    nodes: [],
    isMobile: false,
    isMedium: false,
    pageDirection: 'ltr',
    selector: {
      defaultFilter: '.js-filterable-products__grid-item-prefilter',
      container: '.js-filterable-products-block, .js-mpp-custom-override-layout',
      filters: '.js-filterable-products__filter-set',
      grid: '.js-filterable-products__grid',
      item: '.js-filterable-products__grid-item, .js-filterable-content__grid-item',
      tout: '.js-grid--mpp__item-tout',
      filtered: 'js-filterable-products__grid--filtered',
      unfiltered: 'js-filterable-products__grid--unfiltered',
      filterBtn: '.js-filterable-products-filter-set-button',
      filterTitle: '.js-filterable-products-filter-set__title',
      filterSection: '.js-filterable-products__filter-set-section',
      filterSets: '.js-filterable-products-filter-set__filters',
      filterSetsWrapper: '.js-filterable-products-filter-set__filters-wrapper',
      filterButtonMobile: '.js-filterable-products__filter-set-label',
      filterSetsBody: '.js-filterable-products__filter-set-body',
      filterButtonSpanMobile: '.js-filterable-products__filter-set-label span',
      filterArrow: '.filterable-products__filter-arrow',
      filterWrapper: '.js-filterable-products__wrapper',
      resetBtn: '.js-reset-link',
      unfilterBtn: '.js-filterable-products-unfilter-button',
      productCount: '.js-filterable-products_product-count',
      productCountNumber: '.js-filterable-products_product-count--number',
      filtersContainer: '.js-filters_container',
      ghostFilterContainer: '.js-filters_container--ghost',
      productGrid: '.js-product-grid',
      filterSmooshes: '.js-filterable-products-filter-set__button-wrapper-smoosh',
      modelImagesContainer: '.js-mpp-model-images__container',
      filterSet: '.js-filterable-products__filter-set',
      fixedHeadersWrapper: '.js-site-header-fixed-wrapper',
      briefShadeItem: '.js-product-brief-shades-item'
    },
    cssClass: {
      filtered: 'filterable-products__grid--filtered',
      unfiltered: 'filterable-products__grid--unfiltered',
      hasModelImages: 'js-mpp-has-model-images',
      ghostFilterContainer: 'js-filters_container--ghost'
    },
    urlString: window.location.href,
    hasPrefilters: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      var self = this;

      self.pageDirection = $('html', context).attr('dir') || 'ltr';
      var $modelImgContainer = $('.mpp-model-images__container', context);

      if ($modelImgContainer.length > 0) {
        $(self.selector.filters).addClass(self.cssClass.hasModelImages);
      }
      self.nodes.$pageFixedHeader = $(self.selector.fixedHeadersWrapper, context);
      self.nodes.$pageFixedHeader.data('initialHeight', self.nodes.$pageFixedHeader.height());
      self.setup(context);
    },

    removePcProperties: function ($that) {
      $that.nodes.$filtersContainer.removeClass('fixed').css({ top: '' });
      $that.nodes.$filterWrapper.css({ height: '' });
      $that.nodes.$filterSetsBody.css({ height: '' });
    },

    removeMobileProperties: function ($that) {
      $that.nodes.$filterWrapper.css({ height: '' });
      $that.nodes.$filterSetsBody.css({ height: '' });
      $that.nodes.$filterBtnSpanMobile.text($that.nodes.$filterBtnsMobile.data('filterLabel'));
      $that.nodes.$filterSections.removeClass('closed');
    },

    adjustFilterSectionHeight: function ($that) {
      // reset height before increasing it depending on filters
      var initialHeight = $that.nodes.$filterWrapper.data('initialHeight');
      var newHeight = 0;
      var visibleFilterSetHeight = 0;
      var $visibleFilterSet = $that.nodes.$filterSets.filter(':visible');

      if ($that.nodes.$filterSections.hasClass('open')) {
        initialHeight = $that.nodes.$filterSetsBody.height();
      }

      $that.nodes.$filterWrapper.css('height', initialHeight);
      if ($visibleFilterSet.length > 0) {
        visibleFilterSetHeight = $visibleFilterSet.height();
        initialHeight = $that.nodes.$filterWrapper.data('initialHeight');
      }

      if (visibleFilterSetHeight > 0) {
        newHeight = initialHeight + visibleFilterSetHeight;
        $that.nodes.$filterWrapper.data('currentHeight', newHeight).css({ height: newHeight });
      }
    },

    setFilterBtnMobile: function ($that) {
      // split the filter btn text by ":" as we shouldn't have it on mobile
      var filterByText = $that.nodes.$filterBtnsMobile.data('filterLabel');
      var newFilterByText = '';

      if (!!newFilterByText && filterByText.indexOf(':') !== -1) {
        newFilterByText = filterByText.split(':');
        $that.nodes.$filterBtnSpanMobile.text(newFilterByText[0]);
      }
    },

    filterSetFixedPosition: function ($that) {
      var self = this;
      var initialPosition = $that.nodes.$filtersContainer.data('initialTopPosition');
      var currentScrollTop = $(window).scrollTop();

      // we need to redo the initialTopPosition due to lazyload from header
      $that.nodes.$filtersContainer.once('lazy-initial-top-position', function () {
        var $this = $that.nodes.$filtersContainer;

        if ($this.hasClass('fixed')) {
          // we don't want to save the top position while fixed
          return;
        }
        initialPosition = $this.position().top;
        $this.data('initialTopPosition', $this.position().top);
      });
      if (currentScrollTop === 0 && !$that.nodes.$filtersContainer.hasClass('scroll-fail-check')) {
        // only remove once in case the user refreshed the page while being in the midle of it
        $that.nodes.$filtersContainer
          .removeClass('lazy-initial-top-position-processed')
          .addClass('scroll-fail-check');
      }
      var startOffset = initialPosition;
      var lastScrollTop = $that.nodes.$filtersContainer.data('lastScrollTop') || 0;

      if (currentScrollTop > startOffset) {
        // need to add 5 px so the filter bar doesn't show on nav hover / open
        if (currentScrollTop <= lastScrollTop + 50) {
          self.slideDownFiltersBar($that);
        } else {
          $that.nodes.$filtersContainer.data('lastScrollTop', currentScrollTop);
          self.slideUpFiltersBar($that);
        }
      }
      if (currentScrollTop <= startOffset || currentScrollTop === 0) {
        $that.nodes.$filtersContainer.data('lastScrollTop', currentScrollTop);
        $that.nodes.$ghostFilterContainer
          .hide()
          .removeClass('smooth-load-processed')
          .css({ height: 0 });
        $that.nodes.$filtersContainer
          .removeClass('fixed animating hiding showing')
          .css({ top: '' });
      }
    },

    slideUpFiltersBar: function ($that) {
      var self = this;

      if ($that.nodes.$filtersContainer.hasClass('hiding')) {
        return;
      }
      var top = -self.nodes.$pageFixedHeader.height() - $that.nodes.$filtersContainer.height();

      $that.nodes.$filtersContainer
        .once('animating')
        .addClass('hiding')
        .removeClass('showing')
        .animate(
          {
            top: top
          },
          500,
          function () {
            $that.nodes.$filtersContainer.removeClass('animating-processed');
          }
        );
    },

    showGhostContainer: function ($that) {
      $that.nodes.$ghostFilterContainer.once('smooth-load', function () {
        $that.nodes.$filtersContainer.data('currentHeight', $that.nodes.$filtersContainer.height());
        $that.nodes.$ghostFilterContainer
          .show()
          .css({ height: 0 })
          .animate(
            {
              height: $that.nodes.$filtersContainer.data('currentHeight') + 'px'
            },
            200
          );
        $that.nodes.$filtersContainer.animate(
          {
            height: 0
          },
          215,
          function () {
            $that.nodes.$filtersContainer.addClass('fixed').css({ height: '' });
          }
        );
      });
    },

    slideDownFiltersBar: function ($that) {
      var self = this;

      if ($that.nodes.$filtersContainer.hasClass('showing')) {
        return;
      }
      var currentfixedHeadersHeight = self.nodes.$pageFixedHeader.height();
      var top = self.nodes.$pageFixedHeader.data('initialHeight');

      self.showGhostContainer($that);
      if (currentfixedHeadersHeight !== top) {
        top = currentfixedHeadersHeight;
      }
      $that.nodes.$filtersContainer
        .once('animating')
        .addClass('showing')
        .css({ top: 0 })
        .removeClass('hiding')
        .animate(
          {
            top: top
          },
          500,
          function () {
            $that.nodes.$filtersContainer.removeClass('animating-processed');
          }
        );
    },

    setRandomValues: function ($that) {
      var randomValues = [];

      if ($that.nodes.$filterBtns.filter('[data-has-image]').length > 0) {
        var $imageFilters = $that.nodes.$filterBtns.filter('[data-has-image]');
        var $asRandom = $imageFilters.filter('[data-as-random]');

        // only enable random if the filters are set from CMS as random values
        if ($asRandom.length > 0) {
          $asRandom.each(function () {
            randomValues.push($(this).data('filterValue'));
          });
        }
      } else if (!!$that.data('randomPattern')) {
        $that
          .data('randomPattern')
          .split(',')
          .forEach(function (pattern) {
            randomValues.push(pattern.trim());
          });
      }

      if (!!randomValues) {
        $that.data('randomValues', randomValues);
        $that.nodes.$container.data('hasRandomization', true);
      }
    },

    setup: function (context) {
      var self = this;

      self.attached = true;
      var $filterBlocks = $(self.selector.filters, context);

      self.isMobile = self.checkIfMobile();
      self.isMedium = self.checkIfMedium();
      $filterBlocks.each(function () {
        var $this = $(this);

        self.initDOM($this);
        self.hasPrefilters = self.deepLinkFilter($this);
        self.setInitialDomData($this);
        self.setRandomValues($this);
        Unison.on('change', function () {
          self.isMobile = self.checkIfMobile();
          self.isMedium = self.checkIfMedium();
          self.swapLayout($this);
        });
        self.buildFilters($this);
        self.setEvents($this);
        if (self.hasPrefilters) {
          self.setPrefilterString($this);
        }
      });
    },

    setPrefilterString: function ($that) {
      var self = this;

      if (self.urlString) {
        var filters = self.getActiveFilters($that);
        var filterString = '';
        // trigger event to filter skus
        $(document).trigger('grid.activeFilter', { skuFilters: filters.allSkuFilters });
        self.filterShadeGrid($that, filters);

        filterString = self.getFilterString(
          filters.allAndfilters,
          filters.allOrfilters,
          self.selector.defaultFilter
        );
        $that.nodes.$grid.data('preFilterString', filterString);
      }
    },

    deepLinkFilter: function ($that) {
      var self = this;
      var params = new URL(document.location).searchParams;
      if (params.has('filter')) {
        self.setGridState($that, true);
        var $currentFilter = '';
        var filterValues = params.get('filter').split(',');

        filterValues.forEach(function (val) {
          $currentFilter = $that.nodes.$filterBtns.filter(
            '[data-filter=".filterable-product-grid__item--filter-' + val + '"]'
          );
          if ($currentFilter.length > 0) {
            $currentFilter.addClass('active');
            $currentFilter.each(function () {
              var $this = $(this);
              self.toggleFilterSection($this, $that);
              if (!!$this.data('hasImage')) {
                self.imageSwap($this, $that, false);
                $that.data('prefilterImageElem', $this);
              }
            });
          }
        });
        self.updateAvailableFilters($that);
        return true;
      }
      return false;
    },

    changeFilterParam: function ($that) {
      var self = this;
      var filterParameter = [];
      var params = new URL(document.location).searchParams;
      var urlString = self.urlString.split('?')[0];
      $that.nodes.$filterBtns.filter('.active').each(function () {
        var $this = $(this);
        filterParameter.push($this.data('filterValue'));
      });
      if (filterParameter.length > 0) {
        params.set('filter', filterParameter.join(','));
      } else {
        params.delete('filter');
      }
      window.history.pushState(
        {},
        '',
        urlString + (params.toString() ? '?' + params.toString() : '')
      );
      self.urlString = window.location.href;
    },

    triggerFilter: function ($that) {
      var self = this;
      $that.nodes.$filterSets.each(function () {
        var $this = $(this);
        var defaultFilter = $this.data('defaultFilter');
        var $thisUnfilteredBtn = $this.find($that.nodes.$unfilterBtn);
        if (!!defaultFilter) {
          $this.children('[data-filter-value=' + defaultFilter + ']').trigger('click');
        } else if ($thisUnfilteredBtn.length > 0) {
          $thisUnfilteredBtn.trigger('click');
        }
      });
      $that.nodes.$filterSections.filter(':visible').first().trigger('click');
      self.changeFilterParam($that);
    },

    setInitialDomData: function ($that) {
      var self = this;

      if ($that.nodes.$filterWrapper.length > 0) {
        $that.nodes.$filterWrapper.data('initialHeight', $that.nodes.$filterWrapper.height());
      }
      if ($that.nodes.$filtersContainer.length > 0) {
        $that.nodes.$filtersContainer.data(
          'initialTopPosition',
          $that.nodes.$filtersContainer.position().top
        );
        if ($that.nodes.$ghostFilterContainer.length < 1) {
          $that.nodes.$ghostFilterContainer = $(
            '<div class="' + self.cssClass.ghostFilterContainer + '">'
          );
          $that.nodes.$ghostFilterContainer.insertAfter($that.nodes.$filtersContainer);
        }
      }
      if ($that.nodes.$filterSmooshes.length > 0) {
        $that.nodes.$container.addClass('has-smooshes');
      }
      if ($that.nodes.$filterSets.length > 0) {
        // generate and unique identifier to use for OR / AND logic
        $that.nodes.$filterSets.each(function (i) {
          $(this).data('filterSetIdentifier', i).attr('data-filter-set-identifier', i);
          $(this)
            .find($that.nodes.$filterBtns)
            .data('filterSetIdentifier', i)
            .attr('data-filter-set-identifier', i);
        });
      }
    },

    initDOM: function ($this) {
      var self = this;

      $this.nodes = {};
      $this.nodes.$container = $this.closest(self.selector.container);
      $this.nodes.$grid = $this.nodes.$container.find(self.selector.grid);
      $this.nodes.$items = $this.nodes.$grid.find(self.selector.item);
      $this.nodes.$products = $this.nodes.$items.filter(':not(' + self.selector.tout + ')');
      $this.nodes.$filterSections = $this.find(self.selector.filterSection);
      $this.nodes.$filterSets = $this.find(self.selector.filterSets);
      $this.nodes.$filterSetsWrapper = $this.find(self.selector.filterSetsWrapper);
      $this.nodes.$filterWrapper = $this.closest(self.selector.filterWrapper);
      $this.nodes.$filterSetsBody = $this.find(self.selector.filterSetsBody);
      $this.nodes.$filterBtns = $this.find(self.selector.filterBtn);
      $this.nodes.$filterSmooshes = $this.find(self.selector.filterSmooshes);
      $this.nodes.$filterBtnsMobile = $this.find(self.selector.filterButtonMobile);
      $this.nodes.$filterBtnSpanMobile = $this.find(self.selector.filterBtnSpanMobile);
      $this.nodes.$filterArrow = $this.find(self.selector.filterArrow);
      $this.nodes.$filterTitles = $this.find(self.selector.filterTitle);
      $this.nodes.$filtersContainer = $this.closest(self.selector.filtersContainer);
      $this.nodes.$ghostFilterContainer = $this.closest(self.selector.ghostFilterContainer);
      $this.nodes.$modelImagesContainer = $this.find(self.selector.modelImagesContainer);
      $this.nodes.$resetBtn = $this.find(self.selector.resetBtn);
      $this.nodes.$unfilterBtn = $this.find(self.selector.unfilterBtn);
      $this.nodes.$productCount = $this.find(self.selector.productCount);
      $this.nodes.$productCountNumber = $this.find(self.selector.productCountNumber);
      $this.nodes.$filterSet = $this;
    },

    checkIfMobile: function () {
      if (!!Unison.fetch.now()) {
        var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
        var bPlargeUp = parseInt(Unison.fetch.all()['usn-medium'], 10);

        return currentBpWidth <= bPlargeUp;
      }

      return false;
    },

    checkIfMedium: function () {
      if (!!Unison.fetch.now()) {
        var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
        var bPlargeUp = parseInt(Unison.fetch.all()['usn-large'], 10);

        return currentBpWidth <= bPlargeUp;
      }

      return false;
    },

    toggleImageFilters: function ($that, eventData) {
      var self = this;
      var $toggleFilters = $that.nodes.$filterTitles.filter(
        '.js-filterable-products-filter-set--has-image'
      );

      if ($toggleFilters.length < 1) {
        return;
      }
      var $curentSection = $toggleFilters.closest($that.nodes.$filterSections);

      if (eventData !== 'product') {
        if (
          $that.nodes.$filterBtnsMobile.filter(':visible').length > 0 &&
          !$that.nodes.$filterSections.hasClass('open')
        ) {
          self.toggleMobileFilters($that);
        }
        $curentSection.removeClass('hidden');
        $toggleFilters.addClass('current show');
        $toggleFilters.filter(':visible').trigger('click');
        $curentSection.find('.js-filterable-products-filter-set--has-image').addClass('show');
      } else {
        if ($curentSection.hasClass('current')) {
          if (Drupal.settings.globals_variables.cr21) {
            $toggleFilters.filter(':visible').filter('.selected').trigger('click');
          } else {
            $toggleFilters.filter(':visible').trigger('click');
          }
        }
        $curentSection.find($that.nodes.$filterBtns).filter('.active').trigger('click');
        $toggleFilters.removeClass('show');
        $curentSection.find('.js-filterable-products-filter-set--has-image').removeClass('show');
        $curentSection.find($that.nodes.$filterBtns).removeClass('active');
        $curentSection.addClass('hidden');
      }
    },

    blurLastElem: function ($that) {
      var self = this;
      if (
        !self.isMobile ||
        !$('.js-filterable-products__filter-set').hasClass('filter-layout--pills')
      ) {
        return;
      }
      var parentWidth = $that.width();
      var filteredCopyColor = $that
        .closest('.js-filterable-products__filter-set')
        .data('filtered-copy-color');
      var $blurContainer = $('<div class="blur-last-filter"></div>').css(
        'background',
        'linear-gradient(to right, transparent, ' + filteredCopyColor + ')'
      );
      var $currentFilterSet = $that.find('.current');
      var $currentFilter = $currentFilterSet.find('.js-filterable-products-filter-set__filters');
      if (
        $currentFilterSet.find('.blur-last-filter').length === 0 &&
        $currentFilter.width() > parentWidth
      ) {
        $currentFilter.after($blurContainer);
      }
    },

    setEvents: function ($that) {
      var self = this;

      $that.nodes.$container.on('filterable_products:newItems', function () {
        self.initDOM($that);
        self.buildFilters($that);
        self.imageSwap($(), $that, true);
        self.updateAvailableFilters($that);
      });
      // keeping this lines commented, untill brand knows for sure it wants filters available on results
      // $that.nodes.$container.on('filterable_products:initResults', function() {
      //   disable all filter buttons once the resutls are initialized
      //   $that.nodes.$filterBtns.addClass('disabled');
      // });
      $that.nodes.$grid.on('mpp-toggle-image', function (e, eventData) {
        self.toggleImageFilters($that, eventData);
      });
      // Collect each filter
      $that.nodes.$filterBtns.each(function () {
        var $this = $(this);

        $this
          .once()
          .on('click', function (event) {
            if ($this.hasClass('busy')) {
              return;
            }
            event.preventDefault();
            self.filterTriggered($this, $that);
          })
          .keyup(function (event) {
            if (event.keyCode === 13) {
              if ($this.hasClass('busy')) {
                return;
              }
              event.preventDefault();
              self.filterTriggered($this, $that);
            }
          })
          .hover(
            function () {
              if (
                !$this.hasClass('disabled') &&
                !$this.hasClass('touched') &&
                !$this.hasClass('busy')
              ) {
                $this.addClass('hover');
              }
            },
            function () {
              $this.removeClass('hover');
            }
          )
          .on('touchstart', function () {
            if ($this.hasClass('busy')) {
              return;
            }

            $this.addClass('touched');
          });
      });

      $that.nodes.$filterSections.once().on('click', function () {
        if (self.isMobile || self.isMedium) {
          $that.nodes.$filterSections.removeClass('current');
          $(this).addClass('current');
          self.draggable($(this), $that);
          self.blurLastElem($that);
        }
      });

      $that.nodes.$resetBtn.once().click(function (event) {
        event.preventDefault();
        if ($(this).hasClass('button--disabled') || $(this).hasClass('busy')) {
          return;
        }
        self.reset($that);
      });

      $that.nodes.$unfilterBtn.once().click(function (e) {
        e.preventDefault();
        var $thisBtn = $(this);

        if (
          $thisBtn.hasClass('button--disabled') ||
          $thisBtn.hasClass('busy') ||
          $thisBtn.hasClass('active')
        ) {
          return;
        }
        $thisBtn.closest($that.nodes.$filterSets).find($that.nodes.$filterBtns).css('color', '');
        $thisBtn.closest($that.nodes.$filterSets).find('.active').trigger('click');
        $thisBtn.addClass('active');
        var filteredCopyColor = $thisBtn
          .closest('.js-filterable-products__filter-set')
          .data('filtered-copy-color');
        if (!!filteredCopyColor && !self.isMobile) {
          $thisBtn.css('color', filteredCopyColor);
        } else {
          $thisBtn.css('color', '');
        }
      });

      $that.nodes.$grid.on('arrangeComplete', function () {
        self.toggleFilterButtons($that);
        self.setBusyState($that, false);
      });

      $that.nodes.$grid.on('mixEnd', function () {
        self.toggleFilterButtons($that);
        self.setBusyState($that, false);
      });

      $that.nodes.$grid.on('mpp-show-product-count', function () {
        self.updateProductCount($that);
      });

      if ($that.nodes.$filtersContainer.length > 0) {
        $that.nodes.$filterTitles.once().on('click', function () {
          var $this = $(this);
          self.toggleFilterTitles($this, $that);
        });
      }
      // keep this as the functionality is there, and might be required
      // $(window).scroll(_.debounce(function() {
      //  if (self.isMobile || self.isMedium) {
      //    return;
      //  }
      //  self.filterSetFixedPosition($that);
      // }, 50));

      $that.nodes.$filterBtnsMobile.once().on('click', function () {
        self.toggleMobileFilters($that);
      });
    },

    toggleFilterTitles: function ($this, $that) {
      var self = this;
      $that.nodes.$filterSections.removeClass('current');
      $this.closest($that.nodes.$filterSections).addClass('current');
      if (!$that.nodes.$filtersContainer.hasClass('expanded')) {
        $that.nodes.$filtersContainer.addClass('expanded').removeClass('closed');
      }
      if ($that.nodes.$filtersContainer.hasClass('expanded') && $this.hasClass('selected')) {
        $that.nodes.$filtersContainer.removeClass('expanded').addClass('closed');
        $this.removeClass('selected');
      } else {
        $that.nodes.$filterTitles.removeClass('selected');
        $this.addClass('selected');
        $that.nodes.$filtersContainer.addClass('expanded').removeClass('closed');
      }
      self.adjustFilterSectionHeight($that);
      self.draggable($this, $that);
    },
    closeAllFilterTitles: function ($that) {
      var self = this;
      var $activeFilterTitles = $that.nodes.$filterTitles.filter('.selected');

      if ($activeFilterTitles.length < 1) {
        return;
      }
      $activeFilterTitles.each(function () {
        self.toggleFilterTitles($(this), $that);
      });
    },
    toggleMobileFilters: function ($that) {
      var self = this;

      if (!self.isMobile && !self.isMedium) {
        return;
      }
      if ($that.nodes.$filterSections.hasClass('open')) {
        self.closeAllFilterTitles($that);
        $that.nodes.$filterArrow.removeClass('open');
        $that.nodes.$filterSections.addClass('closed').removeClass('open');
        $that.nodes.$filterWrapper
          .css('height', $that.nodes.$filterWrapper.data('initialHeight'))
          .addClass('no-visible-filters');
      } else {
        $that.nodes.$filterArrow.addClass('open');
        $that.nodes.$filterSections.addClass('open').removeClass('closed');
        $that.nodes.$filterSetsBody.css('height', $that.nodes.$filterSetsBody.height());

        var $visibleFilterSet = $that.nodes.$filterSets.filter(':visible');

        //        $that.nodes.$filterWrapper.css('height', $visibleFilterSet.height());

        $that.nodes.$filterWrapper
          .css('height', $that.nodes.$filterSetsBody.height())
          .removeClass('no-visible-filters');
      }
      $that.nodes.$filterSections.filter(':visible').first().addClass('first');
      $that.nodes.$filterSections.filter(':visible').last().addClass('last');
    },

    updateProductCount: function ($that) {
      var visibleProducts = $that.nodes.$products.filter(':visible').length;

      $that.nodes.$productCountNumber.html(visibleProducts);
      $that.nodes.$productCount.removeClass('hidden');
    },

    processTags: function (tagsData) {
      if (typeof tagsData !== 'string') {
        return [];
      }
      // cleaning specific char's since we have accent values comming from .NET that need to stay
      var newData = tagsData.replace(/['`~!@#$%^&*()|+=?;:'".<>\{\}\[\]\\\/]/gi, '').toLowerCase();
      // Loop through our tags, split them by comma, then trim the whitespace
      var tags = _.map(newData.split(','), $.trim);

      return tags;
    },

    hasFilters: function ($this, properTags, filterType, $filterSets) {
      var hasFilters = false;
      var filterClass = '';

      // Loop through our tags, and add the class to this product item
      _.each(properTags, function (index) {
        filterClass = 'filterable-product-grid__item--filter-' + index;
        $this.addClass(filterClass);
        hasFilters = true;
        if ($filterSets.length) {
          // show the filter when called from product
          $filterSets
            .find('[data-filter=".' + filterClass + '"]')
            .data('filterType', filterType)
            .attr('data-filter-type', filterType)
            .removeClass('hidden');
        }
      });

      return hasFilters;
    },

    productItemHasFilters: function ($item, $that) {
      var self = this;
      var data = '';
      var properTags = '';
      var hasSkuFilters = false;
      var hasFilters = false;

      if ($item.data('attributes').tags) {
        data = $item.data('attributes').tags;
        // process product filters first
        properTags = self.processTags(data);
        // loop tags and add filter class to element
        hasFilters = self.hasFilters($item, properTags, 'product-filter', $that.nodes.$filterSets);
      }

      if ($item.data('attributes').skuTags) {
        data = $item.data('attributes').skuTags;
        // process sku filters first
        properTags = self.processTags(data);
        // loop tags and add filter class to element + filter type
        hasSkuFilters = self.hasFilters($item, properTags, 'sku-filter', $that.nodes.$filterSets);
        if (!hasFilters && hasSkuFilters) {
          hasFilters = true;
        }
        self.processShadesForFiltering($item.find(self.selector.briefShadeItem));
      }

      return hasFilters;
    },

    contentItemHasFilters: function ($item, $that) {
      var self = this;
      var hasFilters = false;
      if ($item.data('contentFilter')) {
        properTags = [$item.data('contentFilter')];
        // loop tags and add filter class to element + filter type
        return self.hasFilters($item, properTags, 'content-filter', $that.nodes.$filterSets);
      }
      return hasFilters;
    },

    buildFilters: function ($that) {
      var self = this;
      var hasFilters = false;

      // Loop through all items
      $that.nodes.$items.once().each(function () {
        var $item = $(this);

        // If not filterable, continue
        if (
          !$item.data('contentFilter') &&
          !!$item.data('attributes') &&
          !$item.data('attributes').tags &&
          !$item.data('attributes').skuTags
        ) {
          return;
        }

        if (!!$item.data('attributes')) {
          hasFilters = self.productItemHasFilters($item, $that);
        }
        if (!!$item.data('contentFilter')) {
          hasFilters = self.contentItemHasFilters($item, $that);
        }
      });

      if (hasFilters) {
        // show the filters pannel if there are is least 1 filter available
        $that.removeClass('hidden');
      }

      // Loop through our filter sets and hide any without filters with tags
      $that.nodes.$filterSets.each(function () {
        var $this = $(this);

        if ($this.children().filter(':not(.hidden)').length < 1) {
          $this.closest($that.nodes.$filterSections).hide();
        }
        if ($that.nodes.$container.hasClass('has-image-toggle') && !!$this.data('hasImage')) {
          // hide the section that is handled by image toggle
          $this.closest($that.nodes.$filterSections).addClass('hidden');
        }
      });
      // check if section is handled by image toggle
      $that.nodes.$filterSections.find('.js-filterable-products-filter-set--has-image');
      self.desktopLayout($that);
      if (self.isMobile || self.isMedium) {
        self.swapLayout($that);
      }
    },

    desktopLayout: function ($that) {
      var maxWidth = $that.nodes.$grid.width();
      var filterSetWidth = 0;
      var filtersWidth = 0;
      var rowIndex = 0;

      $that.nodes.$filterSections.removeClass('row last');
      $that.nodes.$filterSetsBody.removeClass('multi-rows');
      $that.nodes.$filterSections.each(function () {
        var $this = $(this);

        filterSetWidth = $this.width();
        filtersWidth += filterSetWidth;
        if (filtersWidth > maxWidth) {
          rowIndex = parseInt(filtersWidth / maxWidth);
          $this.addClass('row row--' + rowIndex);
          $that.nodes.$filterSetsBody.addClass('multi-rows');
        }
      });
      $that.nodes.$filterSections.filter(':visible').first().addClass('first');
      $that.nodes.$filterSections.filter(':not(.row):visible').last().addClass('last');
    },

    processShadesForFiltering: function ($shades) {
      var self = this;

      if ($shades.length < 1) {
        return;
      }
      $.each($shades, function () {
        var $thisShade = $(this);

        if ($thisShade.data('attributes').tags) {
          var tags = self.processTags($thisShade.data('attributes').tags);

          self.hasFilters($thisShade, tags, 'sku-filter', {});
        }
      });
    },

    swapLayout: function ($that) {
      var self = this;
      var isPillsLayout = $that.hasClass('filter-layout--pills');

      $that.nodes.$filterBtns.removeClass('touched');
      $that.nodes.$filterSections.removeClass('current');
      // $that.nodes.$filterSections.removeClass('current');
      $that.nodes.$filterSets
        .removeClass('draggable js-draggable-processed')
        .css({ transform: '' });
      // remove inline css added for draggable alignment
      $that.nodes.$filterBtns.filter('.js-align-draggable').css({
        'padding-left': '',
        'padding-right': ''
      });

      // MPP specific functionality
      if ($that.nodes.$filtersContainer.length > 0) {
        if (self.isMobile || self.isMedium) {
          var $selectedPcFilterTitles = $that.nodes.$filterTitles.filter('.selected');

          $selectedPcFilterTitles.each(function () {
            // set the selected class on the mobile specific titles on layout change
            $(this)
              .closest($that.nodes.$filterSections)
              .find($that.nodes.$filterTitles)
              .addClass('selected');
          });
          self.setFilterBtnMobile($that);
          self.removePcProperties($that);
          if ($selectedPcFilterTitles.length > 0) {
            // if there is a section selected, we need to open expend the filters
            self.toggleMobileFilters($that);
          }
          self.adjustFilterSectionHeight($that);
        } else {
          self.removeMobileProperties($that);
          self.adjustFilterSectionHeight($that);
        }
      }
      // end MPP specific

      if (self.isMobile || self.isMedium) {
        var $initialSection = isPillsLayout
          ? $that.nodes.$filterSetsBody.find('.current')
          : $that.nodes.$filterSections.filter(':visible').first();

        $initialSection.addClass('current');
        self.blurLastElem($that);
        self.draggable($initialSection, $that);
      }
      if (!self.isMobile) {
        self.desktopLayout($that);
      }
      self.triggerFilter($that);
    },

    draggable: function ($this, $that) {
      var self = this;
      var $container = $this.find($that.nodes.$filterSetsWrapper);
      var $draggableElem = $this.find($that.nodes.$filterSets);
      var initialWidth = $draggableElem.width();
      var settings = {
        reinit: false,
        dirrection: 'x',
        pageDirection: self.pageDirection,
        $container: $container,
        $draggableElem: $draggableElem
      };

      self.draggableDiv(settings);
      if (initialWidth > $container.width()) {
        // allign first item
        self.alignDraggableElement($that, settings);
      }
    },

    alignDraggableElement: function ($that, settings) {
      var self = this;
      var rDirection = self.pageDirection === 'rtl' ? 'left' : 'right';
      var lDirection = self.pageDirection === 'rtl' ? 'right' : 'left';
      var hasFilterTitle = $that.nodes.$filterTitles.length > 0;
      var $firstTitle = hasFilterTitle
        ? $that.nodes.$filterTitles.filter(':visible').first()
        : $that.nodes.$filterSections.filter(':visible').first();
      var $activeFilters = $that.nodes.$filterSets.filter(':visible').first();
      var requiredLeft =
        self.pageDirection !== 'rtl'
          ? $firstTitle.position().left + $firstTitle.offset().left
          : ($firstTitle.outerWidth(true) - $firstTitle.width()) / 2;
      var $firstButton = settings.$draggableElem
        .find($that.nodes.$filterBtns)
        .filter(':visible')
        .first();
      var currentLeft =
        self.pageDirection !== 'rtl'
          ? $firstButton.position().left + $firstButton.offset().left
          : $activeFilters.outerWidth(true) -
            $firstButton.position().left -
            $firstButton.outerWidth(true);
      var $lastButton = settings.$draggableElem
        .find($that.nodes.$filterBtns)
        .filter(':visible')
        .last();
      var rightOffset = ($lastButton.outerWidth(true) - $lastButton.width()) / 2;

      if (!hasFilterTitle) {
        $that.nodes.$filterSections.css('border', 'none');
      }

      if (requiredLeft !== currentLeft) {
        $lastButton
          .addClass('js-align-draggable')
          .css('padding' + self.capitalizeString(rDirection), requiredLeft + 'px');
        rightOffset = 0;
        settings.$draggableElem.data('rightOffset', rightOffset);
        $firstButton
          .addClass('js-align-draggable')
          .css('padding' + self.capitalizeString(lDirection), requiredLeft + 'px');
        // need to reinitialize dragabble
        settings.reinit = true;
        self.draggableDiv(settings);
      }
    },

    capitalizeString: function (str) {
      if (typeof str !== 'string') {
        return '';
      }

      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    setGridState: function ($that, filtered) {
      var self = this;
      if (!!filtered) {
        $that.nodes.$grid.addClass(self.selector.filtered);
        $that.nodes.$grid.addClass(self.cssClass.filtered);
        $that.nodes.$grid.removeClass(self.cssClass.unfiltered);
      } else {
        $that.nodes.$grid.removeClass(self.selector.filtered);
        $that.nodes.$grid.removeClass(self.cssClass.filtered);
        $that.nodes.$grid.addClass(self.cssClass.unfiltered);
      }
    },

    toggleFilterButtons: function ($that) {
      var self = this;
      var filterActive = $that.nodes.$filterBtns.filter('.active').length || false;

      if (filterActive) {
        self.setGridState($that, true);
        $that.nodes.$filtersContainer.addClass('filtered');
        $that.nodes.$filterSet.addClass('filtered');
      } else {
        $that.nodes.$filtersContainer.removeClass('filtered');
        $that.nodes.$filterSet.removeClass('filtered');
      }
    },

    simulateFilterCount: function ($that, $simulatedFilter) {
      var self = this;
      var filters = self.getActiveFilters($that, $simulatedFilter);
      var filterString = '';

      filterString = self.getFilterString(
        filters.allAndfilters,
        filters.allOrfilters,
        self.selector.defaultFilter
      );
      return parseInt($that.nodes.$items.filter(filterString).length);
    },

    updateAvailableFilters: function ($that) {
      var self = this;

      $that.nodes.$filterBtns.filter(':not(.active)').each(function () {
        var $this = $(this);
        var simulateCount = self.simulateFilterCount($that, $this);
        self.toggleFilterElement(simulateCount, $this, $that);
      });
      // full dynamic filters toggle ( disable active filters if results will be 0 )
      var $filterTriggeredObj = $that.nodes.$filterBtns.filter('.filter-in-progress:not(.active)');

      if ($filterTriggeredObj.length > 0) {
        $filterTriggeredObj.parent().find($that.nodes.$filterBtns).addClass('activeSibling');
        // recheck Filters still active
        $that.nodes.$filterBtns.filter('.active:not(.activeSibling)').each(function () {
          var $this = $(this);
          var simulateCount = self.simulateFilterCount($that, $this);

          self.toggleFilterElement(simulateCount, $this, $that);
          self.toggleFilterSection($this, $that);
        });
        $filterTriggeredObj.removeClass('filter-in-progress');
        $that.nodes.$filterBtns.removeClass('activeSibling');
      }
    },

    toggleFilterElement: function (count, $el, $that) {
      var self = this;

      if (count === 0) {
        if ($el.hasClass('active')) {
          self.filterTriggered($el, $that);
        }
        $el.addClass('disabled');
      } else {
        $el.removeClass('disabled');
      }
    },

    getActiveFilters: function ($that, $simulatedFilter) {
      var self = this;
      var filters = {};

      filters.allAndfilters = [];
      filters.allSkuFilters = [];
      filters.allSkuAndfilters = [];
      filters.allOrfilters = [];
      filters.allSkuOrFilters = [];
      var activeFiltersCount = 0;
      var filterSetIdentifier = 0;
      var ignoreSiblings = false;
      var setFilterData = function (arr, value) {
        if (typeof arr === 'undefined') {
          arr = [];
        }
        arr.push(value);

        return arr;
      };
      var $activeBtns = $that.nodes.$filterBtns.filter('.active');

      if (!!$simulatedFilter) {
        $activeBtns = $activeBtns.add($simulatedFilter);
        ignoreSiblings = true;
        $simulatedFilter.parent().find($that.nodes.$filterBtns).data('ignoreSibling', true);
        $simulatedFilter.data('ignoreSibling', false);
      }
      $activeBtns.each(function () {
        var $this = $(this);

        if (ignoreSiblings && $this.data('ignoreSibling')) {
          $this.data('ignoreSibling', false);

          return;
        }
        filterSetIdentifier = $this.data('filterSetIdentifier');
        // flags if the values should be used with OR / AND operator
        var allowMultiValues = $this.data('allowMultipleValues');

        if (!allowMultiValues) {
          filters.allAndfilters.push($this.data('filter'));
          if ($this.data('filterType') === 'sku-filter') {
            filters.allSkuFilters.push($this.data('filter'));
          }
          if (!!$this.data('filterShadePicker') && $this.data('filterType') === 'sku-filter') {
            filters.allSkuAndfilters.push($this.data('filter'));
          }
        } else {
          filters.allOrfilters[filterSetIdentifier] = setFilterData(
            filters.allOrfilters[filterSetIdentifier],
            $this.data('filter')
          );
          if (!!$this.data('filterShadePicker') && $this.data('filterType') === 'sku-filter') {
            filters.allSkuOrFilters[filterSetIdentifier] = setFilterData(
              filters.allSkuOrFilters[filterSetIdentifier],
              $this.data('filter')
            );
          }
        }
      });

      activeFiltersCount = filters.allAndfilters.length;

      return filters;
    },

    getFilterString: function (filters, multiValues, defaultValue) {
      var self = this;
      var filterString = filters.join('') || defaultValue;

      var addToStr = function (str, value) {
        var arr = str.split(',');

        arr = arr.map(function (val) {
          return val + value;
        });

        return arr.join(',');
      };

      // Hide promo items when filters are active
      if (filters.length > 0 && self.selector.item.indexOf(',') !== false) {
        filterString = addToStr(self.selector.item, filterString);
      } else if (filters.length > 0) {
        filterString = filterString + self.selector.item;
      }
      if (multiValues.length > 0) {
        multiValues.forEach(function (multiVals, i) {
          var tmpMulti = [];

          multiVals.forEach(function (val) {
            var filterStringTmp = filterString + val;

            if (filterString.indexOf(',') !== -1) {
              filterStringTmp = addToStr(filterString, val);
            }
            tmpMulti.push(filterStringTmp);
          });
          filterString = tmpMulti.join(',');
        });
      }
      return filterString;
    },

    filterShadeGrid: function ($that, filters) {
      var self = this;

      var filterShadePickerString = self.getFilterString(
        filters.allSkuAndfilters,
        filters.allSkuOrFilters,
        ''
      );
      // trigger event to filter shade brief skus
      $that.nodes.$grid.trigger('grid.shadePickerFilters', {
        filterString: filterShadePickerString
      });
    },

    filter: function ($that) {
      var self = this;

      if ($that.nodes.$container.data('currentView') === 'results') {
        $that.nodes.$container.trigger('filterable_products:switchView', [{ view: 'showGrid' }]);
      }

      var filters = self.getActiveFilters($that);
      var filterString = '';

      // trigger event to filter skus
      $(document).trigger('grid.activeFilter', { skuFilters: filters.allSkuFilters });

      self.filterShadeGrid($that, filters);

      filterString = self.getFilterString(
        filters.allAndfilters,
        filters.allOrfilters,
        self.selector.defaultFilter
      );

      if (
        !!$that.nodes.$grid.data('isotope') &&
        $that.nodes.$grid.data('isotope')._isLayoutInited === true
      ) {
        self.filterIsotope($that, filterString);
      }
      if ($that.nodes.$grid.hasClass('mixitup-initialized')) {
        self.filterMixItUp($that, filterString);
      }
      self.changeFilterParam($that);
    },

    setBusyState: function ($that, isBusy) {
      if (isBusy) {
        $that.nodes.$filterBtns.addClass('busy');
        $that.nodes.$resetBtn.addClass('busy');
      } else {
        $that.nodes.$filterBtns.removeClass('busy');
        $that.nodes.$resetBtn.removeClass('busy');
      }
    },

    filterMixItUp: function ($that, filterString) {
      var self = this;

      self.setBusyState($that, true);
      if (filterString === self.selector.defaultFilter) {
        self.reset($that);
      } else {
        $that.nodes.$grid.mixItUp('filter', filterString);
      }
    },

    filterIsotope: function ($that, filterString) {
      var self = this;

      self.setBusyState($that, true);
      $that.nodes.$grid.fadeTo(300, 0.4, function () {
        if (filterString === self.selector.defaultFilter) {
          self.reset($that);
        } else {
          $that.nodes.$grid.trigger('stateChanged');
          $that.nodes.$grid.isotope({ filter: filterString });
        }
      });
    },

    toggleFilterSetActiveState: function ($this, $that) {
      var self = this;
      var $thisUnfilteredBtn = $this
        .closest($that.nodes.$filterSets)
        .find($that.nodes.$unfilterBtn);
      var siblingFiltersActive = false;
      var filteredCopyColor = $this.closest($that).data('filtered-copy-color') || '';
      var $currentFilters = $this.closest($that.nodes.$filterSets).find($that.nodes.$filterBtns);

      // only toggle active state if the filter set doesn't allow multiple values
      if (!$this.data('allowMultipleValues')) {
        $currentFilters.not($this).removeClass('active').css('color', '');
      } else {
        siblingFiltersActive = $currentFilters.not($this).filter('.active').length > 0;
      }
      $thisUnfilteredBtn.css('color', '');
      $this.toggleClass('active');

      if ($this.hasClass('active')) {
        // If filter was just selected, we deactivate default filter
        $thisUnfilteredBtn.removeClass('active').css('color', '');
      } else if (!siblingFiltersActive) {
        $thisUnfilteredBtn.addClass('active');
        !self.isMobile ? $thisUnfilteredBtn.css('color', filteredCopyColor) : null;
      }
      if (!!filteredCopyColor && $this.hasClass('active') && !self.isMobile) {
        $this.css('color', filteredCopyColor);
      } else {
        $this.css('color', '');
      }
    },

    filterTriggered: function ($this, $that) {
      var self = this;

      if ($this.hasClass('disabled')) {
        return;
      }
      self.toggleFilterSetActiveState($this, $that);
      // enable the toggle if filters should update dynamic based on selection
      if ($that.nodes.$container.data('enableFilterToggle')) {
        $this.addClass('filter-in-progress');
        self.updateAvailableFilters($that);
      }
      self.toggleFilterSection($this, $that);

      self.filter($that);
      self.toggleFilterButtons($that);
      $that.data('prefilterImageElem', '');
      self.imageSwap($this, $that, false);
    },

    toggleFilterSection: function ($this, $that) {
      if ($this.closest($that.nodes.$filterSections).find('.active').length > 0) {
        $this
          .closest($that.nodes.$filterSections)
          .find($that.nodes.$filterTitles)
          .first()
          .addClass('filtered');
      } else {
        $this
          .closest($that.nodes.$filterSections)
          .find($that.nodes.$filterTitles)
          .first()
          .removeClass('filtered');
      }
    },

    imageSwap: function ($this, $that, forceSwap) {
      if (!!$that.data('prefilterImageElem')) {
        $this = $that.data('prefilterImageElem');
      }
      var imagePath = $that.data('imageFolder') || '';
      var filterValue = $this.data('filterValue');
      var randomValues = $that.data('randomValues') || null;
      var randomize =
        (!$that.hasClass('js-image-swap-active') &&
          !$that.hasClass('js-random-image-swap-active')) ||
        forceSwap;
      var useFilter = false;

      // reset filterValue from grid ( used for image swap on MPP )
      $that.nodes.$grid.data('filterValueAsImage', '');

      if ($this.data('hasImage')) {
        if ($this.hasClass('active')) {
          $that.nodes.$grid.data('filterValueAsImage', filterValue);
          $that.addClass('js-image-swap-active').removeClass('js-random-image-swap-active');
          useFilter = true;
          randomize = false;
        } else {
          $that.nodes.$container.trigger('filterable_products:resetImage');
          $that.removeClass('js-image-swap-active');
          useFilter = false;
          randomize = true;
        }
      }

      if (useFilter && imagePath === '') {
        $that.nodes.$grid.trigger('filterable_products:swapImage', { filterValue: filterValue });
      }
      if (imagePath === '') {
        return;
      }
      if (useFilter) {
        $that.nodes.$container.trigger('filterable_products:swapImage', {
          imagePath: imagePath,
          filterValue: filterValue
        });
      }
      if (randomize && !!randomValues) {
        // only randomize if the main filter is not active
        $that.nodes.$container.trigger('filterable_products:randomSwapImage', {
          imagePath: imagePath,
          randomValues: randomValues,
          forceSwap: forceSwap
        });
        $that.addClass('js-random-image-swap-active');
      }
    },

    clearFilters: function ($that) {
      var self = this;

      $that.nodes.$filterBtns.removeClass('active');
      $that.nodes.$filterTitles.removeClass('filtered');
      self.updateAvailableFilters($that);
      $that.nodes.$container.trigger('filterable_products:resetImage');

      if ($that.nodes.$container.data('currentView') === 'results') {
        $that.nodes.$container.trigger('filterable_products:switchView', [{ view: 'showGrid' }]);
      }

      $that.removeClass('js-image-swap-active').removeClass('js-random-image-swap-active');
    },

    reset: function ($that) {
      var self = this;

      self.clearFilters($that);
      $that.nodes.$grid.data('filterValueAsImage', '');
      self.setGridState($that, false);
      self.toggleFilterButtons($that);
      $that.nodes.$grid.trigger('stateChanged');
      if ($that.nodes.$grid.data('isotope')) {
        $that.nodes.$grid.isotope({ filter: self.selector.defaultFilter });
      }
      if ($that.nodes.$grid.hasClass('mixitup-initialized')) {
        $that.nodes.$grid.addClass('reseting-filters').mixItUp('filter', 'all');
      }
      $that.nodes.$container.trigger('grid.reset.filters');
      self.changeFilterParam($that);
    },

    draggableDiv: function (settings) {
      var direction = settings.dirrection;
      var $container = settings.$container;
      var $draggableElem = settings.$draggableElem;
      var pageDirection = settings.pageDirection;
      var reinit = settings.reinit || false;
      var isDraggable =
        $container.hasClass('js-draggable-processed') ||
        $draggableElem.hasClass('js-draggable-processed');

      if (!$draggableElem.is(':visible') || (isDraggable === true && reinit === false)) {
        return;
      }
      var mouseX,
        mouseY,
        elmTop,
        elmLeft,
        diffX,
        newElmTop,
        newElmLeft,
        diffY,
        rightBarrier,
        bottomBarrier,
        leftBarrier,
        topBarrier;
      var isMouseDown = false;
      var containerWidth = $container.width();
      var containerHeight = $container.height();
      var elmWidth = $draggableElem.width();
      var elmHeight = $draggableElem.height();

      function mouseDown(e) {
        isMouseDown = true;
        if (direction === 'x') {
          mouseX = e.clientX
            ? e.clientX
            : e.touches
            ? e.touches[0].clientX
            : e.originalEvent.touches
            ? e.originalEvent.touches[0].clientX
            : false;
        }
        if (direction === 'y') {
          mouseY = e.clientY
            ? e.clientY
            : e.touches
            ? e.touches[0].clientY
            : e.originalEvent.touches
            ? e.originalEvent.touches[0].clientY
            : false;
        }
        if (!mouseX && !mouseY) {
          isMouseDown = false;

          return;
        }
        if (direction === 'y') {
          elmTop = $draggableElem.offset().top;
          diffY = mouseY - elmTop;
        }
        if (direction === 'x') {
          elmLeft = $draggableElem.offset().left;
          diffX = mouseX - elmLeft;
        }
      }

      function mouseUp(e) {
        isMouseDown = false;
      }

      function mouseMove(e) {
        var $this = $(this);
        var $lastElem = $this.find('.js-filterable-products-filter-set-button').last();

        if (!isMouseDown) {
          return;
        }
        e.preventDefault();
        if (direction === 'y') {
          var newMouseY = e.clientY
            ? e.clientY
            : e.touches
            ? e.touches[0].clientY
            : e.originalEvent.touches
            ? e.originalEvent.touches[0].clientY
            : null;

          newElmTop = newMouseY - diffY;

          topBarrier = containerHeight - elmHeight;
          if (newElmTop < topBarrier || newElmTop > bottomBarrier) {
            if (newElmTop < topBarrier) {
              newElmTop = topBarrier;
            }
            if (newElmTop > bottomBarrier) {
              newElmTop = bottomBarrier;
            }
          }
          $draggableElem.css({ transform: 'translate3d(0, ' + newElmTop + 'px, 0)' });
        }
        var extraScroll = 50;

        if (direction === 'x') {
          var newMouseX = e.clientX
            ? e.clientX
            : e.touches
            ? e.touches[0].clientX
            : e.originalEvent.touches
            ? e.originalEvent.touches[0].clientX
            : null;
          var increment = newMouseX > mouseX ? 1 : -1;

          newElmLeft = newMouseX + extraScroll * increment - diffX;
          rightBarrier = 0;
          bottomBarrier = 0;
          leftBarrier = containerWidth - elmWidth;
          if (reinit === true && $draggableElem.data('rightOffset') > 0) {
            leftBarrier += $draggableElem.data('rightOffset');
          }
          if (pageDirection !== 'rtl') {
            if (newElmLeft < leftBarrier) {
              newElmLeft = leftBarrier;
            } else if (newElmLeft > rightBarrier) {
              newElmLeft = rightBarrier;
            }
          } else {
            leftBarrier = leftBarrier * -1;
            if (newElmLeft > leftBarrier) {
              newElmLeft = leftBarrier;
            } else if (newElmLeft < rightBarrier) {
              newElmLeft = rightBarrier;
            }
          }
          $this.removeClass('remove-blur');
          if (newElmLeft !== elmLeft) {
            $draggableElem.css({ transform: 'translate3d(' + newElmLeft + 'px, 0, 0)' });
          }
          if ($lastElem.offset().left + $lastElem.outerWidth(true) < $this.width() + 30) {
            $this.addClass('remove-blur');
          }
        }
      }
      if (reinit === true && isDraggable === true) {
        $container.removeClass('js-draggable-processed').off('mousemove touchmove');
        $draggableElem
          .removeClass('js-draggable-processed')
          .off('mousedown touchstart mouseup touchend');
      }
      $container.once('js-draggable').on('mousemove touchmove', _.debounce(mouseMove, 8));
      $draggableElem
        .once('js-draggable')
        .on('mousedown touchstart', mouseDown)
        .on('mouseup touchend', mouseUp);
      $draggableElem.addClass('draggable');
    },
    attached: false
  };
})(jQuery);
